import { headerImageFor, seoFor } from './page-presentation';
import type { SitePageSummary } from './types';

export function PageHeaderImage({ page, priority = false, className = '' }: { page: SitePageSummary; priority?: boolean; className?: string }) {
  const image = seoFor(page).image ?? headerImageFor(page);
  return (
    <figure className={`page-header-image page-header-image--${image.variant} ${className}`.trim()}>
      <img
        src={image.src}
        alt={image.alt}
        width={image.width}
        height={image.height}
        loading={priority ? 'eager' : 'lazy'}
        fetchPriority={priority ? 'high' : 'auto'}
        decoding="async"
      />
    </figure>
  );
}
